import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router'
import { observer } from 'mobx-react-lite'

import { Breadcrumbs, Button, CardsFilter, type ICardFilter, Table, Typography } from 'shared/ui'
import { makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import { type TollFreeProfileNumber } from 'entities/Compliance/model'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { SettingsPath } from 'pages/settings/route/settingsPath'
import styles from './styles.module.scss'
import { getUseCaseColumns } from './columns'

export const UseCaseDetails = observer(() => {
  const { profile_id } = useParams()

  const {
    useCaseDetailsStore: {
      activeTabKey,
      activeTabNumbers,
      cardsItems,
      activeUseCase,
      searchValue,
      init,
      setActiveTabKey,
      openDetailsModal,
      setSearchValue,
      setActiveNumber,
      learnMoreModalAction,
    },
    addTollFreeNumberStore: { addNumberHandler },
    updateStatusAction,
  } = useTollFreeStepsContext()

  useEffect(() => {
    init(Number(profile_id))
  }, [])

  const updateAction = (item: TollFreeProfileNumber) => {
    setActiveNumber(item)
    updateStatusAction(Number(profile_id), item.id)
  }

  const columns = useMemo(
    () => getUseCaseColumns(openDetailsModal, updateAction, learnMoreModalAction),
    []
  )

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <Breadcrumbs
          getLabel={() => 'Toll-free verification'}
          className={styles.breadcrumbs}
          customPath={`/${SettingsPath.compliance.tollFree.root}`}
        />
        <header className={styles.header}>
          <Typography ariaLabel='useCaseName' variant='heading-lg'>
            {activeUseCase?.use_case?.title || ''}
          </Typography>
          <Button
            text='Add number'
            typeBtn='contained'
            contained='secondary'
            iconProps={{ icon: 'add' }}
            size='medium'
            onClick={() => addNumberHandler()}
          />
        </header>
        <CardsFilter
          activeKey={activeTabKey}
          underline
          items={cardsItems}
          type='simple'
          onActiveFilter={(tab: ICardFilter<string>) => setActiveTabKey(tab.key)}
        />

        <TextField
          value={searchValue}
          onChange={setSearchValue}
          size={'medium'}
          InputProps={{
            placeholder: 'Search...',
            className: styles.searchInput,
          }}
          leftActions={[
            makeTextFieldIcon({
              icon: 'search',
              margin: '0 10px 0 0',
            }),
          ]}
          className={styles.searchTextField}
        />
        <div className={styles.tableWrap}>
          <Table
            ariaLabel={'UseCaseDetails'}
            columns={columns}
            rows={activeTabNumbers}
            noPagination
          />
        </div>
      </div>
    </div>
  )
})
